import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/programs",
)({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ params, pathname }) {
      const isMatchingPrograms =
        pathname === `/athletes/${params.athleteId}/programs`;

      return {
        href: `/athletes/${params.athleteId}/programs`,
        labelTranslationKey: isMatchingPrograms
          ? undefined
          : "programsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
